<template>
    <div class="data-registration-container"
        style="width: 100%; max-width: 1600PX; margin: 10px auto; padding: 0 30px; box-sizing: border-box; overflow: hidden;"
        ref="registrationContainer">

        <el-card class="auth-form-card" shadow="hover" style="width: 100%; max-width: 100%; box-sizing: border-box;">
            <div slot="header" class="clearfix">
                <span style="font-size: 18px;">数据资产登记信息填写</span>
            </div>

            <div class="steps-container" ref="stepsContainer">
                <el-steps :active="activeStep" finish-status="success" align-center key="steps-component"
                    style="margin: 20px 0 30px 1px; width: 100%; max-width: 100%;">
                    <el-step title="基本信息"></el-step>
                    <el-step title="数据属性"></el-step>
                    <el-step title="产权信息"></el-step>
                    <el-step title="合规材料"></el-step>
                    <el-step title="资产详情"></el-step>
                    <el-step title="确认提交"></el-step>
                </el-steps>
            </div>

            <div v-if="activeStep === 0" class="form-step">
                <!-- 温馨提示卡片 -->
                <el-alert
                    type="warning"
                    :closable="false"
                    style="margin-bottom: 24px;">
                    <template slot="title">
                        <div style="display: flex; align-items: flex-start;">
                            <i class="el-icon-info" style="font-size: 16px; margin-right: 8px; margin-top: 2px;"></i>
                            <div>
                                <div style="font-weight: 500; margin-bottom: 8px;">温馨提示</div>
                                <div style="font-size: 13px; color: #606266; line-height: 1.6;">
                                    数据资产登记时需提交数据资产查验报告及数据资产查验详情表，请提前下载模板文件填写后盖章上传。
                                </div>
                                <div style="margin-top: 12px; display: flex; gap: 16px;">
                                    <el-link type="primary" :underline="false" @click="downloadFile('DataReportTemplate.docx')">
                                        <i class="el-icon-download"></i> 数据资产查验报告模板
                                    </el-link>
                                    <el-link type="primary" :underline="false" @click="downloadFile('DataDetailTemplate.xlsx')">
                                        <i class="el-icon-download"></i> 数据资产查验详情表模板
                                    </el-link>
                                    <el-link type="primary" :underline="false" @click="downloadFile('CommitWordTemplate.docx')">
                                        <i class="el-icon-download"></i> 数据资产登记承诺书模板
                                    </el-link>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-alert>

                <el-form label-width="140px" :model="form">
                    <el-form-item label="用戶Id" v-show="false">
                        <el-input v-model="form.userId" :disabled="true"></el-input>
                    </el-form-item>

                    <!-- 基本信息卡片 -->
                    <el-card shadow="never" class="form-section-card" style="margin-bottom: 20px;">
                        <div slot="header" class="section-header">
                            <i class="el-icon-document"></i>
                            <span>基本信息</span>
                        </div>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="登记编号">
                                    <el-input v-model="form.registrationId" :disabled="true" placeholder="系统自动生成"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="数据资产名称" required>
                                    <el-input v-model="form.assetName" placeholder="请输入数据资产名称"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="数据来源" required>
                                    <el-radio-group v-model="form.dataSource">
                                        <el-radio-button label="原始取得">原始取得</el-radio-button>
                                        <el-radio-button label="继受取得">继受取得</el-radio-button>
                                        <el-radio-button label="交易取得">交易取得</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="数据类型" required>
                                    <el-radio-group v-model="form.dataType">
                                        <el-radio-button label="数据资源">数据资源</el-radio-button>
                                        <el-radio-button label="数据产品">数据产品</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="所属行业" required>
                                    <el-cascader
                                        v-model="form.industrys"
                                        :options="industryOptions"
                                        :props="{
                                            expandTrigger: 'hover',
                                            value: 'value',
                                            label: 'label',
                                            children: 'children'
                                        }"
                                        placeholder="请选择所属行业"
                                        style="width: 100%"
                                        clearable
                                        filterable>
                                    </el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="数据覆盖地域" required>
                                    <el-input v-model="form.region" placeholder="请输入数据覆盖地域"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-form-item label="应用场景描述" required>
                            <el-input
                                v-model="form.scenario"
                                type="textarea"
                                :rows="3"
                                placeholder="请详细描述数据资产的应用场景"
                                maxlength="500"
                                show-word-limit>
                            </el-input>
                        </el-form-item>

                        <el-form-item label="数据资产简介" required>
                            <el-input
                                v-model="form.description"
                                type="textarea"
                                :rows="3"
                                placeholder="请简要介绍数据资产的主要内容和特点"
                                maxlength="500"
                                show-word-limit>
                            </el-input>
                        </el-form-item>
                    </el-card>

                    <!-- 联系信息卡片 -->
                    <el-card shadow="never" class="form-section-card">
                        <div slot="header" class="section-header">
                            <i class="el-icon-user"></i>
                            <span>联系信息</span>
                        </div>

                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="联系人姓名" required>
                                    <el-input v-model="form.contactName" placeholder="请输入联系人姓名"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系人手机号" required>
                                    <el-input
                                        @blur="handlePhoneBlur"
                                        v-model="form.contactPhone"
                                        placeholder="请输入11位手机号码"
                                        maxlength="11">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-form>
            </div>

            <div v-if="activeStep === 1" class="form-step">
                <el-form label-width="250px">
                    <el-form-item label="数据结构" required>
                        <el-radio-group v-model="form.dataScaleType">
                            <el-radio-button label="structured">结构化数据</el-radio-button>
                            <el-radio-button label="unstructured">非结构化数据</el-radio-button>
                            <el-radio-button label="composite">复合型数据</el-radio-button>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item v-if="form.dataScaleType === 'structured' || form.dataScaleType === 'composite'"
                        label="数据规模" required>
                        <el-input-number v-model="form.tableCount" :min="1" controls-position="right" style="width: 20%"
                            :disabled="form.dataScaleType === 'unstructured'" placeholder="表数量"></el-input-number>
                        <span> 个数据表&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <el-input-number v-model="form.fieldCount" :min="1" controls-position="right" style="width: 20%"
                            :disabled="form.dataScaleType === 'unstructured'" placeholder="字段数量"></el-input-number>
                        <span> 个字段&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <el-input-number v-model="form.recordCount" :min="1" controls-position="right"
                            style="width: 25%" :disabled="form.dataScaleType === 'unstructured'"
                            placeholder="数据条数"></el-input-number>
                        <span> 条数据</span>
                    </el-form-item>

                    <el-form-item v-if="form.dataScaleType === 'structured' || form.dataScaleType === 'composite'"
                        label="存储空间" required>
                        <el-input-number v-model="form.storageSize" :min="0.1" :step="0.1" controls-position="right"
                            style="width: 20%" placeholder="数值"></el-input-number>
                        <el-select v-model="form.storageUnit" style="width: 100px; margin-left: 10px;">
                            <el-option label="KB" value="KB"></el-option>
                            <el-option label="MB" value="MB"></el-option>
                            <el-option label="GB" value="GB" selected></el-option>
                            <el-option label="TB" value="TB"></el-option>
                            <el-option label="PB" value="PB"></el-option>
                            <el-option label="EB" value="EB"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item v-if="form.dataScaleType === 'unstructured' || form.dataScaleType === 'composite'"
                        label="文件数量" required>
                        <el-input-number v-model="form.fileCount" :min="1" controls-position="right"
                            style="width: 20%"></el-input-number>
                        <span> 个文件&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </el-form-item>

                    <el-form-item label="数据期限" required>
                        <el-date-picker v-model="form.dataStartTime" type="date" placeholder="选择开始时间" :picker-options="{
                            disabledDate: time => {
                                // 开始时间不能晚于当前时间
                                const now = new Date();
                                return time.getTime() > now.getTime();
                            }
                        }"></el-date-picker>
                        <span> &nbsp;至&nbsp;</span>
                        <el-date-picker v-model="form.dataEndTime" type="date" placeholder="选择结束时间" :picker-options="{
                            disabledDate: time => {
                                // 结束时间不能早于开始时间
                                const startDate = form.dataStartTime;
                                const now = new Date();

                                // 结束时间不能早于开始时间
                                if (startDate && time.getTime() < new Date(startDate).getTime()) {
                                    return true;
                                }

                                // 结束时间不能晚于当前时间
                                return time.getTime() > now.getTime();
                            }
                        }"></el-date-picker>

                    </el-form-item>

                    <el-form-item label="更新周期" required style="width: 70%">
                        <el-select v-model="form.updateCycle" placeholder="请选择更新周期">
                            <el-option label="实时" value="realtime"></el-option>
                            <el-option label="每日" value="daily"></el-option>
                            <el-option label="每周" value="weekly"></el-option>
                            <el-option label="每月" value="monthly"></el-option>
                            <el-option label="每季度" value="quarterly"></el-option>
                            <el-option label="每年" value="yearly"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>

            <div v-if="activeStep === 2" class="form-step">
                <el-form label-width="250px">
                    <el-form-item label="权利类型" required
                        :class="{ 'is-error': !rightsTypeValidation.valid && activeStep === 2 }">
                        <el-checkbox-group v-model="rightsTypeSelected" @change="updateRightsType">
                            <el-checkbox label="100">数据资源持有权</el-checkbox>
                            <el-checkbox label="010">数据加工使用权</el-checkbox>
                            <el-checkbox label="001">数据产品经营权</el-checkbox>
                        </el-checkbox-group>
                        <div v-if="!rightsTypeValidation.valid && activeStep === 2" class="el-form-item__error">{{
                            rightsTypeValidation.message }}</div>
                    </el-form-item>
                    <el-form-item label="产权期限" required>
                        <el-date-picker v-model="form.assetsStartTime" type="date" placeholder="选择产权开始时间"
                            :picker-options="{
                                disabledDate: time => {
                                    // 开始时间不能晚于当前时间
                                    const now = new Date();
                                    return time.getTime() > now.getTime();
                                }
                            }">
                        </el-date-picker>
                        <span> &nbsp;至&nbsp;</span>
                        <el-date-picker v-model="form.assetsEndTime" type="date" placeholder="选择产权结束时间" :picker-options="{
                            disabledDate: time => {
                                // 结束时间不能早于开始时间
                                const startDate = form.assetsStartTime;

                                if (startDate && time.getTime() < new Date(startDate).getTime()) {
                                    return true;
                                }

                                // 不限制结束时间是否大于当前时间
                                return false;
                            }
                        }">
                        </el-date-picker>
                    </el-form-item>

                    <el-form-item label="使用限制">
                        <el-input v-model="form.usageLimit" type="textarea" :rows="3" placeholder="请输入使用限制说明">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>

            <!-- @close="handleComplianceClose" @submit-success="handleComplianceSuccess" -->
            <div v-if="activeStep === 3">
                <data-compliance-temp ref="complianceApply" :registration-id="form.registrationId"
                    style="width: 100%; max-width: 100%;" :user-id="form.userId" :compliance-info='complianceInfo'
                    @upload-status-change="handleComplianceUploadStatusChange"
                    @file-uploaded="handleComplianceFileUploaded">
                </data-compliance-temp>
            </div>

            <div v-if="activeStep === 4" class="form-step">
                <!-- 数据资产查验报告 -->
                <el-card class="upload-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <span class="required-mark">*</span>
                        <i class="el-icon-document"></i>
                        <span>数据资产查验报告</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="reportFileChange"
                                :on-remove="handleReportRemove" :file-list="reportFileList" :limit="1" :multiple="false"
                                :show-file-list="false" accept=".pdf,.jpg,.jpeg,.png" :before-upload="validateReportFile">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">点击或拖拽文件到此处<br>
                                    <span style="color: gray; font-size: 10px;">
                                        支持 PDF、JPG、PNG 文件格式 文件大小不得超过{{ maxFileSize }}M
                                    </span>
                                </div>
                            </el-upload>
                            <div class="template-links">
                                <el-link type="primary" :underline="true" @click="downloadFile('DataReportTemplate.docx')">
                                    数据资产查验报告模板下载
                                </el-link>
                                 <span style="margin: 0 10px; color: #dcdfe6;"> | </span>
                                <el-link type="primary" :underline="true" @click="downloadFile('Hash.zip')">
                                    哈希值生成工具下载
                                </el-link>
                            </div>
                        </el-col>
                        <el-col :span="16">
                            <el-row :gutter="0" style="min-height: 210px">
                                <p style="margin-bottom: 10px; font-weight: 500;">已选择文件:</p>
                                <div v-if="reportFileList.length > 0" style="max-height: 180px; overflow-y: auto;">
                                    <el-table :data="reportFileList" style="width: 100%;" border>
                                        <el-table-column prop="name" label="文件名" min-width="180">
                                            <template slot-scope="scope">
                                                <span style="display: flex; align-items: center;">
                                                    <i :class="getFileTypeIcon(scope.row.name)"
                                                        style="margin-right: 8px;"></i>
                                                    <span
                                                        style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                        {{ scope.row.name }}
                                                    </span>
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-if="reportFileList.length > 0 && reportFileList.some(file => file.size !== undefined && file.size !== null && file.size > 0)"
                                            label="大小" width="100">
                                            <template slot-scope="scope">
                                                {{ scope.row.size && scope.row.size > 0 ? formatFileSize(scope.row.size) :
                                                    '-' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="状态" width="100">
                                            <template slot-scope="scope">
                                                <el-tag v-if="scope.row.status === 'ready'" type="info"
                                                    size="small">待上传</el-tag>
                                                <el-tag v-if="scope.row.status === 'parsing'" type="warning"
                                                    size="small">上传中</el-tag>
                                                <el-tag v-if="scope.row.status === 'parsed'" type="success"
                                                    size="small">上传完成</el-tag>
                                                <el-tag v-if="scope.row.status === 'error'" type="danger"
                                                    size="small">上传失败</el-tag>
                                                <el-progress
                                                    v-if="scope.row.status === 'uploading' && scope.row.percentage < 100"
                                                    :percentage="scope.row.percentage" :show-text="false" :stroke-width="6">
                                                </el-progress>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" width="120">
                                            <template slot-scope="scope">
                                                <el-button type="text" @click="singleReportFilesUpload(scope.$index)"
                                                    :disabled="scope.row.status === 'parsing' || scope.row.status === 'uploading'">
                                                    {{ scope.row.parsed ? '重新上传' : '上传' }}
                                                </el-button>
                                                <el-button type="text" @click="removeReportFileFromList(scope.$index)"
                                                    :disabled="scope.row.status === 'parsing' || scope.row.status === 'uploading'">
                                                    删除
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div v-else
                                    style="display: flex; align-items: center; justify-content: center; color: #909399; height: 100px;">
                                    暂无文件
                                </div>
                            </el-row>
                            <el-row :gutter="0" type="flex" justify="center" style="margin-top: 10px;">
                                <el-button @click="clearReportFiles"
                                    :disabled="reportFileList.length === 0 || isUploading">清空列表</el-button>
                                <el-button type="primary" @click="allReportFilesUpload"
                                    :disabled="reportFileList.length === 0 || isUploading">
                                    批量上传
                                </el-button>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-card>

                <!-- 数据资产查验详情表 -->
                <el-card class="upload-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <span class="required-mark">*</span>
                        <i class="el-icon-tickets"></i>
                        <span>数据资产查验详情表</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="detailExcelFileChange"
                                :on-remove="handleDetailExcelRemove" :file-list="detailExcelFileList" :limit="1"
                                :multiple="false" :show-file-list="false" accept=".xlsx,.xls,.pdf,.jpg,.jpeg,.png"
                                :before-upload="validateDetailExcelFile">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">点击或拖拽文件到此处<br>
                                    <span style="color: gray; font-size: 10px;">
                                        支持 pdf，图片，Excel 文件格式 文件大小不得超过{{ maxFileSize }}M
                                    </span>
                                </div>
                            </el-upload>
                            <div class="template-links">
                                <el-link type="primary" :underline="true" @click="downloadFile('DataDetailTemplate.xlsx')">
                                    数据资产查验详情表模板下载
                                </el-link>
                            </div>
                        </el-col>
                        <el-col :span="16">
                            <el-row :gutter="0" style="min-height: 210px">
                                <p style="margin-bottom: 10px; font-weight: 500;">已选择文件:</p>
                                <div v-if="detailExcelFileList.length > 0" style="max-height: 180px; overflow-y: auto;">
                                    <el-table :data="detailExcelFileList" style="width: 100%;" border>
                                        <el-table-column prop="name" label="文件名" min-width="180">
                                            <template slot-scope="scope">
                                                <span style="display: flex; align-items: center;">
                                                    <i :class="getFileTypeIcon(scope.row.name)"
                                                        style="margin-right: 8px;"></i>
                                                    <span
                                                        style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                        {{ scope.row.name }}
                                                    </span>
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-if="reportFileList.length > 0 && reportFileList.some(file => file.size !== undefined && file.size !== null && file.size > 0)"
                                            label="大小" width="100">
                                            <template slot-scope="scope">
                                                {{ scope.row.size && scope.row.size > 0 ? formatFileSize(scope.row.size) :
                                                    '-' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="状态" width="100">
                                            <template slot-scope="scope">
                                                <el-tag v-if="scope.row.status === 'ready'" type="info"
                                                    size="small">待上传</el-tag>
                                                <el-tag v-if="scope.row.status === 'parsing'" type="warning"
                                                    size="small">上传中</el-tag>
                                                <el-tag v-if="scope.row.status === 'parsed'" type="success"
                                                    size="small">上传完成</el-tag>
                                                <el-tag v-if="scope.row.status === 'error'" type="danger"
                                                    size="small">上传失败</el-tag>
                                                <el-progress
                                                    v-if="scope.row.status === 'uploading' && scope.row.percentage < 100"
                                                    :percentage="scope.row.percentage" :show-text="false" :stroke-width="6">
                                                </el-progress>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" width="120">
                                            <template slot-scope="scope">
                                                <el-button type="text" @click="singleDetailExcelFilesUpload(scope.$index)"
                                                    :disabled="scope.row.status === 'parsing' || scope.row.status === 'uploading'">
                                                    {{ scope.row.parsed ? '重新上传' : '上传' }}
                                                </el-button>
                                                <el-button type="text" @click="removeDetailExcelFileFromList(scope.$index)"
                                                    :disabled="scope.row.status === 'parsing' || scope.row.status === 'uploading'">
                                                    删除
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div v-else
                                    style="display: flex; align-items: center; justify-content: center; color: #909399; height: 100px;">
                                    暂无文件
                                </div>
                            </el-row>
                            <el-row :gutter="0" type="flex" justify="center" style="margin-top: 10px;">
                                <el-button @click="clearDetailExcelFiles"
                                    :disabled="detailExcelFileList.length === 0 || isDetailExcelUploading">清空列表</el-button>
                                <el-button type="primary" @click="allDetailExcelFilesUpload"
                                    :disabled="detailExcelFileList.length === 0 || isDetailExcelUploading">
                                    批量上传
                                </el-button>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-card>

                <!-- 数据资产登记承诺书 -->
                <el-card class="upload-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <span class="required-mark">*</span>
                        <i class="el-icon-edit-outline"></i>
                        <span>数据资产登记承诺书</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="bookFileChange"
                                :on-remove="handleBookRemove" :file-list="bookFileList" :limit="1" :multiple="false"
                                :show-file-list="false" accept=".jpg,.jpeg,.png,.pdf">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">点击或拖拽文件到此处<br>
                                    <span style="color: gray; font-size: 10px;">
                                        请下载模板, 填写并盖章后上传电子文件<br />
                                        支持 PDF、JPG和PNG 文件格式 文件大小不得超过{{ maxFileSize }}M
                                    </span>
                                </div>
                            </el-upload>
                            <div class="template-links">
                                <el-link type="primary" :underline="true" @click="downloadFile('CommitWordTemplate.docx')">
                                    数据资产登记承诺书模板下载
                                </el-link>
                            </div>
                        </el-col>
                        <el-col :span="16">
                            <el-row :gutter="0" style="min-height: 210px">
                                <p style="margin-bottom: 10px; font-weight: 500;">已选择文件:</p>
                                <div v-if="bookFileList.length > 0" style="max-height: 180px; overflow-y: auto;">
                                    <el-table :data="bookFileList" style="width: 100%;" border>
                                        <el-table-column prop="name" label="文件名" min-width="180">
                                            <template slot-scope="scope">
                                                <span style="display: flex; align-items: center;">
                                                    <i :class="getFileTypeIcon(scope.row.name)"
                                                        style="margin-right: 8px;"></i>
                                                    <span
                                                        style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                        {{ scope.row.name }}
                                                    </span>
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-if="reportFileList.length > 0 && reportFileList.some(file => file.size !== undefined && file.size !== null && file.size > 0)"
                                            label="大小" width="100">
                                            <template slot-scope="scope">
                                                {{ scope.row.size && scope.row.size > 0 ? formatFileSize(scope.row.size) :
                                                    '-' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="状态" width="100">
                                            <template slot-scope="scope">
                                                <el-tag v-if="scope.row.status === 'ready'" type="info"
                                                    size="small">待上传</el-tag>
                                                <el-tag v-if="scope.row.status === 'parsing'" type="warning"
                                                    size="small">上传中</el-tag>
                                                <el-tag v-if="scope.row.status === 'parsed'" type="success"
                                                    size="small">上传完成</el-tag>
                                                <el-tag v-if="scope.row.status === 'error'" type="danger"
                                                    size="small">上传失败</el-tag>
                                                <el-progress
                                                    v-if="scope.row.status === 'uploading' && scope.row.percentage < 100"
                                                    :percentage="scope.row.percentage" :show-text="false" :stroke-width="6">
                                                </el-progress>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" width="120">
                                            <template slot-scope="scope">
                                                <el-button type="text" @click="singleBookFilesUpload(scope.$index)"
                                                    :disabled="scope.row.status === 'parsing' || scope.row.status === 'uploading'">
                                                    {{ scope.row.parsed ? '重新上传' : '上传' }}
                                                </el-button>
                                                <el-button type="text" @click="removeBookFileFromList(scope.$index)"
                                                    :disabled="scope.row.status === 'parsing' || scope.row.status === 'uploading'">
                                                    删除
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div v-else
                                    style="display: flex; align-items: center; justify-content: center; color: #909399; height: 100px;">
                                    暂无文件
                                </div>
                            </el-row>
                            <el-row :gutter="0" type="flex" justify="center" style="margin-top: 10px;">
                                <el-button @click="clearBookFiles"
                                    :disabled="bookFileList.length === 0 || isBookUploading">清空列表</el-button>
                                <el-button type="primary" @click="allBookFilesUpload"
                                    :disabled="bookFileList.length === 0 || isBookUploading">
                                    批量上传
                                </el-button>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-card>

                <!-- 其他文件 -->
                <el-card class="upload-card" shadow="hover">
                    <div slot="header" class="card-header">
                        <i class="el-icon-folder-opened"></i>
                        <span>其他文件（可选）</span>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-upload ref="upload" drag action='#' :auto-upload="false" :on-change="otherFileChange"
                                :on-remove="handleOtherRemove" :file-list="otherFileList" :limit="10" :multiple="true"
                                :show-file-list="false">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">点击或拖拽文件到此处<br>
                                    <span style="color: gray; font-size: 10px;">
                                        文件大小不得超过{{ maxFileSize }}M
                                    </span>
                                </div>
                            </el-upload>
                        </el-col>
                        <el-col :span="16">
                            <el-row :gutter="0" style="min-height: 210px">
                                <p style="margin-bottom: 10px; font-weight: 500;">已选择文件:</p>
                                <div v-if="otherFileList.length > 0" style="max-height: 180px; overflow-y: auto;">
                                    <el-table :data="otherFileList" style="width: 100%;" border>
                                        <el-table-column prop="name" label="文件名" min-width="180">
                                            <template slot-scope="scope">
                                                <span style="display: flex; align-items: center;">
                                                    <i :class="getFileTypeIcon(scope.row.name)"
                                                        style="margin-right: 8px;"></i>
                                                    <span
                                                        style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                                                        {{ scope.row.name }}
                                                    </span>
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column
                                            v-if="reportFileList.length > 0 && reportFileList.some(file => file.size !== undefined && file.size !== null && file.size > 0)"
                                            label="大小" width="100">
                                            <template slot-scope="scope">
                                                {{ scope.row.size && scope.row.size > 0 ? formatFileSize(scope.row.size) :
                                                    '-' }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="状态" width="100">
                                            <template slot-scope="scope">
                                                <el-tag v-if="scope.row.status === 'ready'" type="info"
                                                    size="small">待上传</el-tag>
                                                <el-tag v-if="scope.row.status === 'parsing'" type="warning"
                                                    size="small">上传中</el-tag>
                                                <el-tag v-if="scope.row.status === 'parsed'" type="success"
                                                    size="small">上传完成</el-tag>
                                                <el-tag v-if="scope.row.status === 'error'" type="danger"
                                                    size="small">上传失败</el-tag>
                                                <el-progress
                                                    v-if="scope.row.status === 'uploading' && scope.row.percentage < 100"
                                                    :percentage="scope.row.percentage" :show-text="false" :stroke-width="6">
                                                </el-progress>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="操作" width="120">
                                            <template slot-scope="scope">
                                                <el-button type="text" @click="singleOtherFilesUpload(scope.$index)"
                                                    :disabled="scope.row.status === 'parsing' || scope.row.status === 'uploading'">
                                                    {{ scope.row.parsed ? '重新上传' : '上传' }}
                                                </el-button>
                                                <el-button type="text" @click="removeOtherFileFromList(scope.$index)"
                                                    :disabled="scope.row.status === 'parsing' || scope.row.status === 'uploading'">
                                                    删除
                                                </el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                                <div v-else
                                    style="display: flex; align-items: center; justify-content: center; color: #909399; height: 100px;">
                                    暂无文件
                                </div>
                            </el-row>
                            <el-row :gutter="0" type="flex" justify="center" style="margin-top: 10px;">
                                <el-button @click="clearOtherFiles"
                                    :disabled="otherFileList.length === 0 || isOtherUploading">清空列表</el-button>
                                <el-button type="primary" @click="allOtherFilesUpload"
                                    :disabled="otherFileList.length === 0 || isOtherUploading">
                                    批量上传
                                </el-button>
                            </el-row>
                        </el-col>
                    </el-row>
                </el-card>

            </div>

            <!-- 第五步：确认提交 -->
            <!-- 第六步：确认提交 -->
            <div v-if="activeStep === 5" class="form-step">
                <div class="confirmation-container">
                    <el-alert type="success" :closable="false" class="confirm-alert">
                        <div slot="title">
                            <i class="el-icon-circle-check"></i>
                            所有材料已准备完成，请确认信息无误后提交
                        </div>
                    </el-alert>

                    <el-card class="summary-card" shadow="never">
                        <div slot="header" class="summary-header">
                            <i class="el-icon-document"></i>
                            <span>基本信息</span>
                        </div>
                        <el-descriptions :column="2" border>
                            <el-descriptions-item label="登记编号">{{ form.registrationId }}</el-descriptions-item>
                            <el-descriptions-item label="数据资产名称">{{ form.assetName }}</el-descriptions-item>
                            <el-descriptions-item label="数据来源">{{ form.dataSource }}</el-descriptions-item>
                            <el-descriptions-item label="数据类型">{{ form.dataType }}</el-descriptions-item>
                            <el-descriptions-item label="所属行业">{{ getIndustryLabel }}</el-descriptions-item>
                            <el-descriptions-item label="数据覆盖地域">{{ form.region }}</el-descriptions-item>
                            <el-descriptions-item label="应用场景" :span="2">{{ form.scenario }}</el-descriptions-item>
                            <el-descriptions-item label="数据资产简介" :span="2">{{ form.description }}</el-descriptions-item>
                            <el-descriptions-item label="联系人">{{ form.contactName }}</el-descriptions-item>
                            <el-descriptions-item label="联系电话">{{ form.contactPhone }}</el-descriptions-item>
                        </el-descriptions>
                    </el-card>

                    <el-card class="summary-card" shadow="never">
                        <div slot="header" class="summary-header">
                            <i class="el-icon-data-line"></i>
                            <span>数据属性</span>
                        </div>
                        <el-descriptions :column="2" border>
                            <el-descriptions-item label="数据结构">
                                {{ form.dataScaleType === 'structured' ? '结构化数据' :
                                   form.dataScaleType === 'unstructured' ? '非结构化数据' : '复合型数据' }}
                            </el-descriptions-item>
                            <el-descriptions-item label="更新周期">{{
                                {'realtime':'实时','daily':'每日','weekly':'每周','monthly':'每月','quarterly':'每季度','yearly':'每年'}[form.updateCycle] || form.updateCycle
                            }}</el-descriptions-item>

                            <!-- 结构化数据：显示表、字段、记录、存储空间 -->
                            <template v-if="form.dataScaleType === 'structured'">
                                <el-descriptions-item label="数据表数量">{{ form.tableCount }}张</el-descriptions-item>
                                <el-descriptions-item label="字段数量">{{ form.fieldCount }}个</el-descriptions-item>
                                <el-descriptions-item label="记录数量">{{ form.recordCount }}条</el-descriptions-item>
                                <el-descriptions-item label="存储空间">
                                    {{ form.storageSize }}{{ form.storageUnit }}
                                </el-descriptions-item>
                            </template>

                            <!-- 非结构化数据：只显示文件数量 -->
                            <template v-else-if="form.dataScaleType === 'unstructured'">
                                <el-descriptions-item label="文件数量">{{ form.fileCount }}个</el-descriptions-item>
                            </template>

                            <!-- 复合型数据：显示所有字段 -->
                            <template v-else-if="form.dataScaleType === 'composite'">
                                <el-descriptions-item label="数据表数量">{{ form.tableCount }}张</el-descriptions-item>
                                <el-descriptions-item label="字段数量">{{ form.fieldCount }}个</el-descriptions-item>
                                <el-descriptions-item label="记录数量">{{ form.recordCount }}条</el-descriptions-item>
                                <el-descriptions-item label="文件数量">{{ form.fileCount }}个</el-descriptions-item>
                                <el-descriptions-item label="存储空间">
                                    {{ form.storageSize }}{{ form.storageUnit }}
                                </el-descriptions-item>
                            </template>

                            <el-descriptions-item label="数据期限" :span="2">
                                {{ formatDisplayDate(form.dataStartTime) }} 至 {{ formatDisplayDate(form.dataEndTime) }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>

                    <el-card class="summary-card" shadow="never">
                        <div slot="header" class="summary-header">
                            <i class="el-icon-lock"></i>
                            <span>产权信息</span>
                        </div>
                        <el-descriptions :column="2" border>
                            <el-descriptions-item label="产权类型" :span="2">
                                <el-tag
                                    :type="form.rightsType && form.rightsType[0] === '1' ? 'success' : 'info'"
                                    size="small" style="margin-right: 8px;">
                                    <i :class="form.rightsType && form.rightsType[0] === '1' ? 'el-icon-check' : 'el-icon-minus'"></i>
                                    数据资源持有权
                                </el-tag>
                                <el-tag
                                    :type="form.rightsType && form.rightsType[1] === '1' ? 'success' : 'info'"
                                    size="small" style="margin-right: 8px;">
                                    <i :class="form.rightsType && form.rightsType[1] === '1' ? 'el-icon-check' : 'el-icon-minus'"></i>
                                    数据加工使用权
                                </el-tag>
                                <el-tag
                                    :type="form.rightsType && form.rightsType[2] === '1' ? 'success' : 'info'"
                                    size="small" style="margin-right: 8px;">
                                    <i :class="form.rightsType && form.rightsType[2] === '1' ? 'el-icon-check' : 'el-icon-minus'"></i>
                                    数据产品经营权
                                </el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="产权期限">
                                {{ formatDisplayDate(form.assetsStartTime) }} 至 {{ formatDisplayDate(form.assetsEndTime) }}
                            </el-descriptions-item>
                            <el-descriptions-item label="使用限制">
                                {{ form.usageLimit || '无' }}
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>

                    <!-- 合规信息材料 -->
                    <el-card class="summary-card" shadow="never">
                        <div slot="header" class="summary-header">
                            <i class="el-icon-shield"></i>
                            <span>合规信息</span>

                        </div>
                        <el-descriptions :column="1" border>
                            <el-descriptions-item label="资质证明材料">
                                <template v-if="complianceSubmitData && complianceSubmitData.qualificationMaterials && complianceSubmitData.qualificationMaterials.length > 0">
                                    <div v-for="(f, i) in complianceSubmitData.qualificationMaterials" :key="i" class="file-name-row">
                                        <i class="el-icon-document" style="margin-right: 6px; color: #409EFF;"></i>{{ f }}
                                    </div>
                                </template>
                                <el-tag v-else type="danger" size="small"><i class="el-icon-close"></i> 未上传</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="数据来源证明材料">
                                <template v-if="complianceSubmitData && complianceSubmitData.dataSourceMaterials && complianceSubmitData.dataSourceMaterials.length > 0">
                                    <div v-for="(f, i) in complianceSubmitData.dataSourceMaterials" :key="i" class="file-name-row">
                                        <i class="el-icon-document" style="margin-right: 6px; color: #409EFF;"></i>{{ f }}
                                    </div>
                                </template>
                                <el-tag v-else type="danger" size="small"><i class="el-icon-close"></i> 未上传</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="数据脱敏处理证明材料">
                                <template v-if="complianceSubmitData && complianceSubmitData.dataSampleMaterials && complianceSubmitData.dataSampleMaterials.length > 0">
                                    <div v-for="(f, i) in complianceSubmitData.dataSampleMaterials" :key="i" class="file-name-row">
                                        <i class="el-icon-document" style="margin-right: 6px; color: #409EFF;"></i>{{ f }}
                                    </div>
                                </template>
                                <el-tag v-else type="info" size="small">无需上传</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="数据存储证明材料">
                                <template v-if="complianceSubmitData && complianceSubmitData.dataStorageMaterials && complianceSubmitData.dataStorageMaterials.length > 0">
                                    <div v-for="(f, i) in complianceSubmitData.dataStorageMaterials" :key="i" class="file-name-row">
                                        <i class="el-icon-document" style="margin-right: 6px; color: #409EFF;"></i>{{ f }}
                                    </div>
                                </template>
                                <el-tag v-else type="danger" size="small"><i class="el-icon-close"></i> 未上传</el-tag>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>

                    <!-- 资产详情材料 -->
                    <el-card class="summary-card" shadow="never">
                        <div slot="header" class="summary-header">
                            <i class="el-icon-files"></i>
                            <span>资产详情</span>
                        </div>
                        <el-descriptions :column="1" border>
                            <el-descriptions-item label="数据资产查验报告">
                                <template v-if="reportFileList.length > 0">
                                    <div v-for="(f, i) in reportFileList" :key="i" class="file-name-row">
                                        <i class="el-icon-document" style="margin-right: 6px; color: #409EFF;"></i>
                                        <span>{{ f.name }}</span>
                                    </div>
                                </template>
                                <el-tag v-else type="danger" size="small"><i class="el-icon-close"></i> 未上传</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="数据资产查验详情表">
                                <template v-if="detailExcelFileList.length > 0">
                                    <div v-for="(f, i) in detailExcelFileList" :key="i" class="file-name-row">
                                        <i class="el-icon-document" style="margin-right: 6px; color: #409EFF;"></i>
                                        <span>{{ f.name }}</span>
                                    </div>
                                </template>
                                <el-tag v-else type="danger" size="small"><i class="el-icon-close"></i> 未上传</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="数据资产登记承诺书">
                                <template v-if="bookFileList.length > 0">
                                    <div v-for="(f, i) in bookFileList" :key="i" class="file-name-row">
                                        <i class="el-icon-document" style="margin-right: 6px; color: #409EFF;"></i>
                                        <span>{{ f.name }}</span>
                                    </div>
                                </template>
                                <el-tag v-else type="danger" size="small"><i class="el-icon-close"></i> 未上传</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item label="其他文件">
                                <template v-if="otherFileList.length > 0">
                                    <div v-for="(f, i) in otherFileList" :key="i" class="file-name-row">
                                        <i class="el-icon-document" style="margin-right: 6px; color: #409EFF;"></i>
                                        <span>{{ f.name }}</span>
                                    </div>
                                </template>
                                <el-tag v-else type="info" size="small">无</el-tag>
                            </el-descriptions-item>
                        </el-descriptions>
                    </el-card>

<div class="submit-tip" style="color: #E6A23C;">
    <i class="el-icon-warning"></i>
    提交后将进入审核流程，请确保所有信息准确无误
</div>
                </div>
            </div>

            <!-- 修改底部按钮逻辑 -->
            <div class="form-actions" ref="actionsContainer">
                <el-button @click="prevStep" :disabled="activeStep === 0" size="medium">上一步</el-button>
                <el-button @click="nextStep" v-if="activeStep < 5" type="primary" size="medium">
                    下一步
                </el-button>
                <el-button @click="submitForm" v-if="activeStep === 5" type="success" :disabled="!canSubmit"
                    size="medium">确认提交</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
import DataComplianceTemp from './DataCompliance/DataComplianceTemp.vue'
export default {
    name: "DataRegistration",
    components: {
        DataComplianceTemp // 注册组件
    },

    data() {
        return {
            // 新增：子组件上传状态
            complianceUploadStatus: {
                hasUploading: false,
                hasUnuploaded: false,
                canProceed: true
            },
            activeStep: 0,
            uploadProgress: 0,
            industries: [],
            industryOptions: [], // 添加行业选项数据
            maxFileSize: 100, // 10MB
            form: {
                userId: "",
                registrationId: '',
                assetName: '',
                dataSource: '',
                industrys: [],
                region: '',
                dataScaleType: 'structured', // 默认结构化数据
                // 结构化数据字段
                tableCount: 1,
                fieldCount: 1,
                recordCount: 1,
                storageSize: 1,
                // 非结构化数据字段
                fileCount: 1,
                // 通用字段
                dataStartTime: '',
                dataEndTime: '',
                updateCycle: '',
                dataStructure: '',
                updateTime: '',
                rightsType: '111', // 初始值为全0
                assetsType: '',
                usageLimit: '',
                reportFiles: null,
                verificationFiles: null,
                commitmentFiles: null,
                otherFiles: null,
                // 添加上传状态字段
                reportFileUploaded: false,
                verificationFileUploaded: false,
                commitmentFileUploaded: false,
                otherFileUploaded: false

            },
            reportFilesName: [],
            verificationFilesName: [],
            commitmentFilesName: [],
            otherFilesName: [],
            rightsTypeSelected: ['100', '010', '001'], // 默认选中全部三个权利类型
            rightsTypeValidation: {
                valid: true,
                message: ''
            }, // 用于校验和显示错误信息

            isUploading: false, // 添加报告上传状态标志
            reportFileList: [], // 添加报告文件列表
            singleReportPromises: [], // 添加单文件上传的Promise列表
            reportUrlList: [],  // 添加报告文件URL列表

            isDetailExcelUploading: false,  // 添加详情表上传状态标志
            detailExcelFileList: [], // 添加详情表文件列表
            singleDetailExcelPromises: [], // 添加详情表文件上传的Promise列表
            detailExcelUrlList: [],  // 添加详情表文件URL列表

            isBookUploading: false,  // 添加承诺书上传状态标志
            bookFileList: [], // 添加承诺书文件列表
            singleBooklPromises: [], // 添加承诺书文件上传的Promise列表
            bookUrlList: [],  // 添加承诺书文件URL列表

            isOtherUploading: false,  // 添加其他文件上传状态标志
            otherFileList: [], // 添加其他文件列表
            singleOtherlPromises: [], // 添加其他文件上传的Promise列表
            otherUrlList: [],  // 添加其他文件URL列表

            complianceInfo: '',  // 合规信息

            // 新增：存储子组件的提交数据
            complianceSubmitData: null,
            complianceCanSubmit: false,

        }
    },
    async mounted() {
        let user = JSON.parse(window.localStorage.getItem('user'));
        this.form.userId = user.id;
        this.activeStep = 0;

        // 设置容器样式
        const container = this.$refs.registrationContainer;
        if (container) {
            container.style.width = '100%';
            container.style.maxWidth = '1600PX';
            container.style.overflow = 'visible';
            container.style.minHeight = '600px';
        }

        await this.fetchIndustryTree();
        if (this.$route.query.registrationId) {
            // 等待行业数据加载完成后再初始化表单
            this.$nextTick(async () => {
                await this.initFormData(this.$route.query.registrationId);
            });
        }
    },
    watch: {
        '$route'(to, from) {
            // 只在路由路径变化时重置步骤，query参数变化不重置
            if (to.path !== from.path) {
                this.activeStep = 0;
                if (to.query.registrationId) {
                    this.initFormData(to.query.registrationId);
                }
            }
        },
        activeStep(newStep, oldStep) {
            console.log('步骤变化:', oldStep, '->', newStep);

            // 当从第4步返回到第3步时，强制重新加载子组件数据
            if (newStep === 3 && oldStep === 4) {
                this.$nextTick(() => {
                    console.log('从第4步返回第3步，重新加载子组件数据');
                    this.refreshComplianceData();
                });
            }

            // 当切换到第三步时，强制检查子组件状态
            if (newStep === 3) {
                this.$nextTick(() => {
                    this.forceCheckComplianceStatus();
                });
            }
        },
        // 监听 complianceInfo 变化，确保子组件能接收到更新
        complianceInfo: {
            handler(newVal) {
                console.log('complianceInfo 发生变化:', newVal);
                // 如果当前在第三步，确保子组件更新
                if (this.activeStep === 3) {
                    this.$nextTick(() => {
                        this.forceCheckComplianceStatus();
                    });
                }
            },
            deep: true
        }
    },
    methods: {
        findIndustryPath(industryName) {
            if (!this.industryOptions || !industryName) return [];

            for (let parent of this.industryOptions) {
                if (parent.children) {
                    for (let child of parent.children) {
                        if (child.label === industryName) {
                            return [parent.value, child.value];
                        }
                    }
                }
            }
            return [];
        },

        parseCommaSeparatedString(str) {
            if (!str) return []

            if (Array.isArray(str)) return str

            if (typeof str === 'string') {
                // 去除空格，按逗号分割
                return str.split(',').map(item => item.trim()).filter(item => item)
            }

            return []
        },

        // 新增方法：从响应数据初始化文件列表
        initFileListsFromResponse(data) {
            console.log("初始化文件列表数据:", data);

            // 初始化报告文件列表
            if (data.reportFile) {
                this.reportFileList = this.parseFileStringToFileList(data.reportFile, 'report');
                this.reportUrlList = this.parseCommaSeparatedString(data.reportFile);
                this.form.reportUrlList = [...this.reportUrlList];
            }

            // 初始化详情表文件列表
            if (data.verificationFile) {
                this.detailExcelFileList = this.parseFileStringToFileList(data.verificationFile, 'detailExcel');
                this.detailExcelUrlList = this.parseCommaSeparatedString(data.verificationFile);
                this.form.detailExcelUrlList = [...this.detailExcelUrlList];
            }

            // 初始化承诺书文件列表
            if (data.commitmentFile) {
                this.bookFileList = this.parseFileStringToFileList(data.commitmentFile, 'book');
                this.bookUrlList = this.parseCommaSeparatedString(data.commitmentFile);
                this.form.bookUrlList = [...this.bookUrlList];
            }

            // 初始化其他文件列表
            if (data.otherFile) {
                this.otherFileList = this.parseFileStringToFileList(data.otherFile, 'other');
                this.otherUrlList = this.parseCommaSeparatedString(data.otherFile);
                this.form.otherUrlList = [...this.otherUrlList];
            }

            console.log("初始化后的文件列表:", {
                reportFileList: this.reportFileList,
                detailExcelFileList: this.detailExcelFileList,
                bookFileList: this.bookFileList,
                otherFileList: this.otherFileList
            });
        },

        // 新增方法：将文件字符串转换为文件列表格式
        parseFileStringToFileList(fileString, fileType) {
            if (!fileString) return [];

            const fileNames = this.parseCommaSeparatedString(fileString);
            if (fileNames.length === 0) return [];

            return fileNames.map(fileName => {
                // 从文件名中提取扩展名
                const ext = fileName.split('.').pop().toLowerCase();

                // 根据文件类型设置不同的状态
                let status = 'parsed'; // 已上传完成
                let parsed = true;

                // 创建模拟的File对象（用于显示）
                const fileObj = {
                    name: fileName,
                    size: 0, // 从后端获取时可能没有大小信息
                    status: status,
                    parsed: parsed,
                    percentage: 100,
                    // 创建模拟的raw对象，用于重新上传
                    raw: new File([], fileName, {
                        type: this.getMimeTypeByExtension(ext)
                    })
                };

                return fileObj;
            });
        },

        // 新增方法：根据扩展名获取MIME类型
        getMimeTypeByExtension(ext) {
            const mimeTypes = {
                'pdf': 'application/pdf',
                'jpg': 'image/jpeg',
                'jpeg': 'image/jpeg',
                'png': 'image/png',
                'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'xls': 'application/vnd.ms-excel',
                'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'doc': 'application/msword'
            };

            return mimeTypes[ext] || 'application/octet-stream';
        },


        async initFormData(registrationId) {
            try {
                const response = await this.getRequest(`/web/dataAssets/queryReview?registrationId=${registrationId}`);

                if (response && response.data) {
                    console.log("7777777777777777777777777777777777777777777");

                    console.log(response.data);

                    // 数据规模类型映射
                    let dataScaleType = response.data.dataScaleType || 'structured';

                    // 如果后端返回的是中文，需要映射为英文标识
                    const scaleTypeMap = {
                        '结构化数据': 'structured',
                        '非结构化数据': 'unstructured',
                        '复合型数据': 'composite',
                    };

                    dataScaleType = scaleTypeMap[dataScaleType] || 'structured';

                    // 填充表单数据
                    this.form = {
                        ...this.form,
                        ...response.data,

                        dataScaleType: dataScaleType,
                        rightsTypes: response.data.rightsTypes || ['数据资源持有权', '数据加工使用权', '数据产品经营权'],
                        // // 处理文件数据
                        // reportFileList: response.data.reportFile,
                        // detailExcelFileList: this.parseCommaSeparatedString(response.data.verificationFile),
                        // // detailExcelFileList: response.data.verificationFile,
                        // bookFileList: response.data.commitmentFile,
                        // otherFileList: response.data.otherFile,

                    };
                    // 处理文件数据回显 - 新增代码
                    this.initFileListsFromResponse(response.data);

                    console.log("初始化后的填充表单数据：");
                    console.log(this.form);

                    // 确保 complianceInfo 正确传递
                    if (response.data.compliance) {
                        this.complianceInfo = response.data.compliance;
                        console.log("设置 complianceInfo:", this.complianceInfo);
                        // 设置合规材料可提交状态
                        this.complianceCanSubmit = true;
                        this.complianceSubmitData = response.data.compliance;
                    } else {
                        this.complianceInfo = {};
                        this.complianceCanSubmit = false;
                        this.complianceSubmitData = null;
                    }

                    // 等待DOM更新后强制刷新子组件状态
                    this.$nextTick(() => {
                        if (this.$refs.complianceApply && response.data.compliance) {
                            console.log('强制刷新合规子组件数据');
                            this.forceCheckComplianceStatus();
                        }
                    });

                    // 特别处理行业数据回显
                    if (response.data.industry) {
                        // 查找行业对应的父子级ID
                        const industryIds = this.findIndustryPath(response.data.industry);
                        if (industryIds.length > 0) {
                            this.$set(this.form, 'industrys', industryIds);
                        }
                    }

                    // 根据模式设置表单状态
                    if (this.$route.query.mode === 'view') {
                        Object.keys(this.form).forEach(key => {
                            if (typeof this.form[key] === 'object' && this.form[key] !== null) {
                                this.form[key].disabled = true;
                            }
                        });
                        this.form.readonly = true;
                        this.$set(this.form, 'title', '查看数据资产登记信息');
                        this.$set(this.form, 'submitButtonText', '返回');
                    } else if (this.$route.query.mode === 'edit') {
                        this.form.readonly = false;
                        this.$set(this.form, 'title', '编辑数据资产登记信息');
                        this.$set(this.form, 'submitButtonText', '保存修改');
                    } else {
                        this.$set(this.form, 'title', '新增数据资产登记信息');
                        this.$set(this.form, 'submitButtonText', '提交审核');
                    }

                    // 强制停留在第一步，无论什么状态
                    this.activeStep = 0;

                    // 设置表单提交方法
                    if (this.$route.query.mode === 'edit') {
                        this.$set(this.form, 'submitMethod', 'update');
                    } else {
                        this.$set(this.form, 'submitMethod', 'create');
                    }
                }
            } catch (error) {
                this.$message.error('初始化表单数据失败: ' + error.message);
            }
        },
        async fetchIndustryTree() {
            try {
                //console.log('开始获取行业数据...');
                // 获取一级行业
                const mainResponse = await this.$axios.get('/web/industry/queryAll');
                //console.log('一级行业响应:', mainResponse);
                const industryTree = await Promise.all(mainResponse.data.list.map(async mainItem => {
                    //console.log(`获取${mainItem.categoryName}的子行业数据...`);
                    // 获取子行业
                    const childrenResponse = await this.$axios.get('/web/industry/queryChildren', {
                        params: { parentId: mainItem.categoryId }
                    });
                    //console.log(`子行业响应(${mainItem.categoryName}):`, childrenResponse);

                    if (!childrenResponse.data || !childrenResponse.data.list) {
                        console.warn(`无效的子行业数据格式: ${mainItem.categoryName}`);
                        return {
                            value: mainItem.categoryId,
                            label: mainItem.categoryName,
                            children: []
                        };
                    }

                    return {
                        value: mainItem.categoryId,
                        label: mainItem.categoryName,
                        children: childrenResponse.data.list.map(childItem => ({
                            value: childItem.categoryId,
                            label: childItem.categoryName
                        }))
                    };
                }));
                this.industryOptions = industryTree;
                //console.log('最终行业选项:', this.industryOptions);
            } catch (error) {
                console.error('获取行业数据失败:', error);
                this.$message.error('获取行业数据失败: ' + error.message);

                // 设置默认行业选项
                this.industryOptions = [{
                    value: 'default',
                    label: '默认行业',
                    children: [{
                        value: 'default-sub',
                        label: '默认子行业'
                    }]
                }];
            }
        },
        async fetchSubIndustries(parentId) {
            try {
                const response = await this.$axios.get('/web/industry/queryChildren', { params: { parentId } });
                this.subIndustries = response.data.list.map(item => ({
                    value: item.categoryId,
                    label: item.categoryName
                }));
                this.showSubIndustry = true;
            } catch (error) {
                console.error('获取子行业失败:', error);
                this.$message.error('获取子行业失败');
            }
        },
        // 验证手机号格式
        validatePhone(phone) {
            if (!phone) return true; // 允许为空，由提交时校验处理必填
            const phoneRegex = /^1[3-9]\d{9}$/;
            return phoneRegex.test(phone);
        },
        // 格式化日期用于显示（将Date对象或字符串格式化为yyyy-MM-dd）
        formatDisplayDate(date) {
            if (!date) return '';
            // 如果已经是 yyyy-MM-dd 格式的字符串，直接返回
            if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
                return date;
            }
            // 转换为Date对象
            const d = new Date(date);
            if (isNaN(d.getTime())) return ''; // 无效日期
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        // 失焦时验证手机号
        handlePhoneBlur() {
            const phone = this.form.contactPhone;
            if (phone && !this.validatePhone(phone)) {
                this.$message.error('请输入正确的手机号格式');
            }
        },
        // 验证日期是否有效（不超过当前时间）
        validateDateNotInFuture(date) {
            if (!date) return true;
            const selectedDate = new Date(date);
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 将今天的时间设为00:00:00，只比较日期
            return selectedDate <= today;
        },
        // 验证结束日期是否晚于开始日期
        validateDateRange(startDate, endDate) {
            if (!startDate || !endDate) return true;
            const start = new Date(startDate);
            const end = new Date(endDate);
            return end >= start;
        },
        async downloadFile(customName) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/template/download/' + customName,
                    responseType: 'blob'
                });

                // 优先使用传入的自定义文件名
                let fileName = customName;
                //这里把文件名替换成中文，上面用英文是避免网络传输乱码问题，这里换成中文文件名下载时就正常了
                if (customName.startsWith('DataDetailTemplate')) {
                    fileName = "数据资产查验详情表-模版.xlsx"
                } else if (customName.startsWith('DataReportTemplate')) {
                    fileName = "数据资产查验报告-模版.docx"
                } else if (customName.startsWith('CommitWordTemplate')) {
                    fileName = "数据资产登记承诺书-模版.docx"
                } else if (customName.startsWith('Hash')) {
                    fileName = "哈希值生成工具.zip"
                }

                // 处理中文文件名编码问题
                const encodedFileName = encodeURIComponent(fileName);

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                link.setAttribute('download-filename', encodedFileName); // 兼容性处理
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },
        handleIndustryChange(value) {
            if (value) {
                this.fetchSubIndustries(value);
                this.form.industry = ''; // 清空主行业选择
            } else {
                this.showSubIndustry = false;
                this.subIndustries = [];
            }
        },

        // 新增：处理子组件上传状态变化
        handleComplianceUploadStatusChange(status) {
            console.log('子组件上传状态变化:', status);

            this.complianceUploadStatus = status;
            this.complianceCanSubmit = status.canSubmit || false;
            this.complianceSubmitData = status.submitData || null;

            // 确保数据被正确设置
            if (status.submitData) {
                console.log('接收到子组件提交数据:', status.submitData);
            }
        },


        // 新增：处理子组件文件上传事件
        handleComplianceFileUploaded(data) {
            console.log('子组件文件上传完成:', data);

            this.complianceCanSubmit = data.canSubmit;
            this.complianceSubmitData = data.submitData;

            // 确保数据被正确设置
            if (data.submitData) {
                console.log('文件上传后提交数据:', data.submitData);
            }
        },
        async nextStep() {
            // 步骤校验
            let isValid = true;
            let errorMessage = '';



            // 第一步校验
            if (this.activeStep === 0) {
                if (!this.form.assetName) {
                    isValid = false;
                    errorMessage = '数据资产名称未填写';
                } else if (!this.form.dataSource) {
                    isValid = false;
                    errorMessage = '数据来源未选择';
                } else if (!this.form.dataType) {
                    isValid = false;
                    errorMessage = '数据类型未选择';
                } else if (!this.form.industrys || this.form.industrys.length < 2) {
                    isValid = false;
                    errorMessage = '所属行业未选择完整';
                } else if (!this.form.region) {
                    isValid = false;
                    errorMessage = '数据覆盖地域未填写';
                } else if (!this.form.scenario) {
                    isValid = false;
                    errorMessage = '应用场景描述未填写';
                } else if (!this.form.description) {
                    isValid = false;
                    errorMessage = '数据资产简介未填写';
                } else if (!this.form.contactName) {
                    isValid = false;
                    errorMessage = '联系人姓名未填写';
                } else if (!this.form.contactPhone) {
                    isValid = false;
                    errorMessage = '联系人手机号未填写';
                } else if (!this.validatePhone(this.form.contactPhone)) {
                    isValid = false;
                    errorMessage = '联系人手机号格式不正确';
                }
            }
            // 第二步校验



            else if (this.activeStep === 1) {
                if (!this.form.dataScaleType) {
                    isValid = false;
                    errorMessage = '数据结构未选择';
                } else if (this.form.dataScaleType === 'structured') {
                    // 结构化数据校验
                    if (!this.form.tableCount || !this.form.fieldCount || !this.form.recordCount) {
                        isValid = false;
                        errorMessage = '结构化数据规模未填写完整';
                    }
                    if (!this.form.storageSize || !this.form.storageUnit) {
                        isValid = false;
                        errorMessage = '存储空间未填写完整';
                    }
                } else if (this.form.dataScaleType === 'unstructured') {
                    // 非结构化数据校验
                    if (!this.form.fileCount) {
                        isValid = false;
                        errorMessage = '文件数量未填写';
                    }
                } else if (this.form.dataScaleType === 'composite') {
                    // 复合型数据校验
                    if ((!this.form.tableCount || !this.form.fieldCount || !this.form.recordCount) &&
                        !this.form.fileCount) {
                        isValid = false;
                        errorMessage = '请至少填写结构化或非结构化数据规模';
                    }
                    if (!this.form.storageSize || !this.form.storageUnit) {
                        isValid = false;
                        errorMessage = '存储空间未填写完整';
                    }
                    if (!this.form.fileCount) {
                        isValid = false;
                        errorMessage = '文件数量未填写';
                    }
                }

                // 数据期限校验
                if (!this.form.dataStartTime || !this.form.dataEndTime) {
                    isValid = false;
                    errorMessage = '数据期限未选择完整';
                }

                // 通用校验
                if (!this.form.dataStartTime || !this.form.dataEndTime) {
                    isValid = false;
                    errorMessage = '数据期限未选择完整';
                }
                if (!this.form.updateCycle) {
                    isValid = false;
                    errorMessage = '更新周期未选择';
                }
            }
            // 第三步校验
            else if (this.activeStep === 2) {
                this.updateRightsType(); // 确保更新二进制编码
                if (!this.rightsTypeValidation.valid) {
                    isValid = false;
                    errorMessage = this.rightsTypeValidation.message;
                    // 滚动到错误位置
                    this.$nextTick(() => {
                        const el = document.querySelector('.is-error');
                        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    });
                } else if (!this.form.assetsStartTime || !this.form.assetsEndTime) {
                    isValid = false;
                    errorMessage = '产权期限未选择完整';
                }
            }
            else if (this.activeStep === 3) {
                console.log('从第三步进入第四步，检查子组件状态');

                // 等待子组件加载完成
                await this.$nextTick();

                // 给子组件更多时间处理数据
                await new Promise(resolve => setTimeout(resolve, 200));

                // 强制检查子组件状态并获取最新数据
                if (this.$refs.complianceApply) {
                    // 先更新子组件的上传状态
                    if (this.$refs.complianceApply.updateUploadStatus) {
                        this.$refs.complianceApply.updateUploadStatus();
                    }

                    // 再次等待状态更新
                    await this.$nextTick();
                    await new Promise(resolve => setTimeout(resolve, 100));

                    // 直接从子组件获取最新状态
                    const childCanSubmit = this.$refs.complianceApply.canSubmit ?
                        this.$refs.complianceApply.canSubmit() : false;
                    const childSubmitData = this.$refs.complianceApply.getSubmitData ?
                        this.$refs.complianceApply.getSubmitData() : null;

                    console.log('子组件状态检查:', {
                        complianceUploadStatus: this.complianceUploadStatus,
                        childCanSubmit: childCanSubmit,
                        childSubmitData: childSubmitData,
                        complianceCanSubmit: this.complianceCanSubmit,
                        complianceSubmitData: this.complianceSubmitData
                    });

                    // 更新父组件的状态
                    if (childCanSubmit) {
                        this.complianceCanSubmit = true;
                    }
                    if (childSubmitData) {
                        this.complianceSubmitData = childSubmitData;
                    }
                }

                // 检查子组件是否有文件正在上传
                if (this.complianceUploadStatus.hasUploading) {
                    this.$message.warning('有文件正在上传中，请等待上传完成');
                    return;
                }

                // 检查子组件是否有未上传的文件
                if (this.complianceUploadStatus.hasUnuploaded) {
                    this.$message.warning('有文件未上传，请先上传所有文件');
                    return;
                }

                // 检查子组件是否可以提交
                if (!this.complianceCanSubmit) {
                    this.$message.warning('请确保所有必需的文件都已上传完成');
                    return;
                }

                // 检查是否有提交数据
                if (!this.complianceSubmitData) {
                    this.$message.warning('请先上传合规材料');
                    return;
                }

                console.log('第三步验证通过，准备进入第四步');
            }
            // 第四步校验：检查文件上传
            else if (this.activeStep === 4) {
                // 检查必需文件是否已上传
                const reportUploaded = this.reportFileList.length > 0 &&
                    this.reportFileList.every(f => f.status === 'parsed');
                const detailUploaded = this.detailExcelFileList.length > 0 &&
                    this.detailExcelFileList.every(f => f.status === 'parsed');
                const bookUploaded = this.bookFileList.length > 0 &&
                    this.bookFileList.every(f => f.status === 'parsed');

                if (!reportUploaded) {
                    isValid = false;
                    errorMessage = '请上传数据资产查验报告';
                } else if (!detailUploaded) {
                    isValid = false;
                    errorMessage = '请上传数据资产查验详情表';
                } else if (!bookUploaded) {
                    isValid = false;
                    errorMessage = '请上传数据资产登记承诺书';
                }

                // 检查是否有文件正在上传
                const hasUploading = this.reportFileList.some(f => f.status === 'parsing' || f.status === 'uploading') ||
                    this.detailExcelFileList.some(f => f.status === 'parsing' || f.status === 'uploading') ||
                    this.bookFileList.some(f => f.status === 'parsing' || f.status === 'uploading') ||
                    this.otherFileList.some(f => f.status === 'parsing' || f.status === 'uploading');

                if (hasUploading) {
                    this.$message.warning('有文件正在上传中，请等待上传完成');
                    return;
                }

                console.log('第四步验证通过，准备进入第五步');
                console.log('文件上传状态检查:', {
                    reportUploaded,
                    detailUploaded,
                    bookUploaded,
                    reportFileList: this.reportFileList,
                    detailExcelFileList: this.detailExcelFileList,
                    bookFileList: this.bookFileList
                });
            }
            if (!isValid) {
                this.$message.error(errorMessage);
                return;
            }

            console.log('开始保存数据，当前步骤:', this.activeStep);
            try {
                // 格式化日期为yyyy-MM-dd字符串
                const formatDate = (date) => {
                    if (!date) return '';
                    const d = new Date(date);
                    const year = d.getFullYear();
                    const month = String(d.getMonth() + 1).padStart(2, '0');
                    const day = String(d.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                };


                const updateCycleMap = {
                    '实时': 'realtime',
                    '每日': 'daily',
                    '每周': 'weekly',
                    '每月': 'monthly',
                    '每季度': 'quarterly',
                    '每年': 'yearly',
                    'realtime': 'realtime',
                    'daily': 'daily',
                    'weekly': 'weekly',
                    'monthly': 'monthly',
                    'quarterly': 'quarterly',
                    'yearly': 'yearly'
                }
                const englishUpdateCycle = updateCycleMap[this.form.updateCycle] || this.form.updateCycle;

                // const submitData = {
                //     ...this.form,

                //     updateCycle: englishUpdateCycle,
                //     industry: this.form.industrys && this.form.industrys.length > 1
                //         ? this.form.industrys[1] : '',
                //     dataStartTime: formatDate(this.form.dataStartTime) == '' ? null : formatDate(this.form.dataStartTime),
                //     dataEndTime: formatDate(this.form.dataEndTime) == '' ? null : formatDate(this.form.dataEndTime),
                //     assetsStartTime: formatDate(this.form.assetsStartTime) == '' ? null : formatDate(this.form.assetsStartTime),
                //     assetsEndTime: formatDate(this.form.assetsEndTime) == '' ? null : formatDate(this.form.assetsEndTime),
                //     companySubmit: this.complianceSubmitData
                // };


                console.log("文件列表：------------");
                console.log("this.reportUrlList.toString(),", this.form.reportUrlList,);
                console.log("this.verificationFile.toString(),", this.form.verificationFile);
                console.log("this.commitmentFile.toString(),", this.form.commitmentFile);
                console.log("this.otherFile.toString(),", this.form.otherFile);
                console.log("complianceSubmitData:", this.complianceSubmitData);


                const submitData = {
                    ...this.form,
                    industry: this.form.industrys && this.form.industrys.length > 1
                        ? this.form.industrys[1] : '',
                    updateCycle: englishUpdateCycle,
                    registrationId: this.form.registrationId,


                    // 将数组转换为逗号分隔的字符串（后端期望String类型）
                    reportFile: Array.isArray(this.form.reportUrlList)
                        ? this.form.reportUrlList.join(',')
                        : (this.form.reportUrlList || ''),
                    verificationFile: Array.isArray(this.form.detailExcelUrlList)
                        ? this.form.detailExcelUrlList.join(',')
                        : (this.form.detailExcelUrlList || ''),
                    commitmentFile: Array.isArray(this.form.bookUrlList)
                        ? this.form.bookUrlList.join(',')
                        : (this.form.bookUrlList || ''),
                    // otherFile后端是List<String>，保持数组格式
                    otherFile: this.form.otherUrlList || [],


                    dataStartTime: formatDate(this.form.dataStartTime),
                    dataEndTime: formatDate(this.form.dataEndTime),
                    assetsStartTime: formatDate(this.form.assetsStartTime),
                    assetsEndTime: formatDate(this.form.assetsEndTime),
                    companySubmit: this.complianceSubmitData ? {
                        ...this.complianceSubmitData,
                        // 确保所有字段都是数组格式
                        qualificationMaterials: Array.isArray(this.complianceSubmitData.qualificationMaterials)
                            ? this.complianceSubmitData.qualificationMaterials
                            : (this.complianceSubmitData.qualificationMaterials ? [this.complianceSubmitData.qualificationMaterials] : []),
                        dataSourceMaterials: Array.isArray(this.complianceSubmitData.dataSourceMaterials)
                            ? this.complianceSubmitData.dataSourceMaterials
                            : (this.complianceSubmitData.dataSourceMaterials ? [this.complianceSubmitData.dataSourceMaterials] : []),
                        dataSampleMaterials: Array.isArray(this.complianceSubmitData.dataSampleMaterials)
                            ? this.complianceSubmitData.dataSampleMaterials
                            : (this.complianceSubmitData.dataSampleMaterials ? [this.complianceSubmitData.dataSampleMaterials] : []),
                        dataStorageMaterials: Array.isArray(this.complianceSubmitData.dataStorageMaterials)
                            ? this.complianceSubmitData.dataStorageMaterials
                            : (this.complianceSubmitData.dataStorageMaterials ? [this.complianceSubmitData.dataStorageMaterials] : [])
                    } : null
                };
                // console.log("complianceSubmitData11111111111111111");
                // console.log(this.complianceSubmitData);

                // // 如果是第三步，将合规数据合并到提交数据中
                // if (this.activeStep === 3 && this.complianceSubmitData) {
                //     Object.assign(submitData, this.complianceSubmitData);
                // }


                console.log("submitData11111");
                console.log(submitData);


                const response = await this.$axios.post('/web/dataAssets/store', submitData);
                console.log("store-response");
                console.log(response);
                if (response.data && response.data.registrationId) {
                    this.form.registrationId = response.data.registrationId;
                    console.log("this.form.registrationId");
                    console.log(this.form.registrationId);
                }

                // 修复步骤跳转逻辑
                console.log('保存成功，准备跳转。当前步骤:', this.activeStep);
                this.activeStep++;
                console.log('跳转后步骤:', this.activeStep);
                if (this.activeStep > 5) this.activeStep = 0;
                //this.$message.success('数据保存成功');
            } catch (error) {
                console.error('保存失败:', error);
                this.$message.error('数据保存失败: ' + (error.response?.data?.message || error.message));
            }
        },

        // 新增：检查子组件必需文件
        checkComplianceRequiredFiles() {
            if (!this.$refs.complianceApply) return false;

            const child = this.$refs.complianceApply;

            // 检查资质文件
            const hasZiZhiFiles = child.ziZhiFiles && child.ziZhiFiles.some(f => f.status === 'uploaded');
            if (!hasZiZhiFiles) {
                this.$message.warning('请上传资质证明材料');
                return false;
            }

            // 检查来源文件
            const hasLaiYuanFiles = child.laiYuanFiles && child.laiYuanFiles.some(f => f.status === 'uploaded');
            if (!hasLaiYuanFiles) {
                this.$message.warning('请上传数据来源证明材料');
                return false;
            }

            // 检查隐私文件（如果需要）
            if (child.needBeProcessed) {
                const hasYinSiFiles = child.yinSiFiles && child.yinSiFiles.some(f => f.status === 'uploaded');
                if (!hasYinSiFiles) {
                    this.$message.warning('请上传数据脱敏处理证明材料');
                    return false;
                }
            }

            // 检查存储文件
            const hasCunChuFiles = child.cunChuFiles && child.cunChuFiles.some(f => f.status === 'uploaded');
            if (!hasCunChuFiles) {
                this.$message.warning('请上传数据存储安全证明材料');
                return false;
            }

            return true;
        },

        // 新增：强制检查子组件状态的方法
        forceCheckComplianceStatus() {
            if (this.$refs.complianceApply) {
                console.log('强制更新子组件状态');

                // 重置初始化标记，允许重新格式化
                if (this.$refs.complianceApply.isInitialized !== undefined) {
                    this.$refs.complianceApply.isInitialized = false;
                }

                // 重新格式化数据
                if (this.$refs.complianceApply.formatComplianceInfo) {
                    this.$refs.complianceApply.formatComplianceInfo();
                }

                // 更新上传状态
                if (this.$refs.complianceApply.updateUploadStatus) {
                    this.$refs.complianceApply.updateUploadStatus();
                }

                // 获取最新的提交数据
                this.$nextTick(() => {
                    if (this.$refs.complianceApply.canSubmit) {
                        this.complianceCanSubmit = this.$refs.complianceApply.canSubmit();
                    }
                    if (this.$refs.complianceApply.getSubmitData) {
                        this.complianceSubmitData = this.$refs.complianceApply.getSubmitData();
                    }
                    console.log('更新后的父组件状态:', {
                        complianceCanSubmit: this.complianceCanSubmit,
                        complianceSubmitData: this.complianceSubmitData
                    });
                });
            }
        },
        // 刷新合规数据
        async refreshComplianceData() {
            try {
                if (this.form.registrationId) {
                    console.log('重新获取合规数据，registrationId:', this.form.registrationId);

                    const response = await this.getRequest(`/web/dataAssets/queryReview?registrationId=${this.form.registrationId}`);

                    if (response && response.data && response.data.compliance) {
                        // 更新 complianceInfo
                        this.complianceInfo = response.data.compliance;
                        console.log('更新后的 complianceInfo:', this.complianceInfo);

                        // 给子组件时间处理新数据
                        this.$nextTick(() => {
                            if (this.$refs.complianceApply && this.$refs.complianceApply.formatComplianceInfo) {
                                // 重置初始化标记，允许重新格式化
                                this.$refs.complianceApply.isInitialized = false;
                                this.$refs.complianceApply.formatComplianceInfo();
                            }

                            // 强制更新状态
                            this.forceCheckComplianceStatus();
                        });
                    }
                }
            } catch (error) {
                console.error('刷新合规数据失败:', error);
            }
        },
        prevStep() {
            const oldStep = this.activeStep;
            if (this.activeStep-- < 0) this.activeStep = 0;

            console.log('执行上一步，从步骤', oldStep, '到步骤', this.activeStep);

            // 如果从第5步返回第4步，需要特殊处理
            if (oldStep === 5 && this.activeStep === 4) {
                console.log('从第5步返回第4步，需要刷新数据');
                // 这里不立即刷新，由 watch 监听处理
            }
        },


        // 获取文件图标
        getFileTypeIcon(filename) {
            const ext = filename.split('.').pop().toLowerCase();
            if (ext === 'xlsx' || ext === 'xls') return 'el-icon-document';
            if (ext === 'docx') return 'el-icon-document';
            return 'el-icon-document';
        },

        // 格式化文件大小
        formatFileSize(size) {
            if (size < 1024) return size + ' B';
            if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
            return (size / 1024 / 1024).toFixed(1) + ' MB';
        },

        // 验证报告文件
        validateReportFile(file) {
            const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const allowedExtensions = ['pdf', 'jpg', 'jpeg', 'png'];

            // 检查文件类型
            const isTypeAllowed = allowedTypes.includes(file.type);
            const isExtensionAllowed = allowedExtensions.includes(fileExtension);

            if (!isTypeAllowed && !isExtensionAllowed) {
                this.$message.error('报告文件只支持 PDF、JPG、PNG 格式');
                return false;
            }

            // 检查文件大小 (maxFileSize MB)
            const isSizeValid = file.size / 1024 / 1024 <= this.maxFileSize;
            if (!isSizeValid) {
                this.$message.error(`文件大小不能超过 ${this.maxFileSize}MB`);
                return false;
            }

            return true;
        },

        // 验证详情表文件
        validateDetailExcelFile(file) {
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel'
            ];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            //const allowedExtensions = ['xlsx', 'xls'];

            // 检查文件类型
            //const isTypeAllowed = allowedTypes.includes(file.type);
            //const isExtensionAllowed = allowedExtensions.includes(fileExtension);

            //if (!isTypeAllowed && !isExtensionAllowed) {
            //    this.$message.error('详情表文件只支持 Excel 格式 (.xlsx, .xls)');
            //  return false;
            //}

            // 检查文件大小
            const isSizeValid = file.size / 1024 / 1024 <= this.maxFileSize;
            if (!isSizeValid) {
                this.$message.error(`文件大小不能超过 ${this.maxFileSize}MB`);
                return false;
            }

            return true;
        },

        // 验证承诺书文件
        validateBookFile(file) {
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf'];

            // 检查文件类型
            const isTypeAllowed = allowedTypes.includes(file.type);
            const isExtensionAllowed = allowedExtensions.includes(fileExtension);

            if (!isTypeAllowed && !isExtensionAllowed) {
                this.$message.error('承诺书文件只支持 PDF、JPG、PNG 格式');
                return false;
            }

            // 检查文件大小
            const isSizeValid = file.size / 1024 / 1024 <= this.maxFileSize;
            if (!isSizeValid) {
                this.$message.error(`文件大小不能超过 ${this.maxFileSize}MB`);
                return false;
            }

            return true;
        },

        // 修改单个文件上传方法，支持重新上传已存在的文件
        singleFilesUpload(fileList, urlList, index) {
            const file = fileList[index];
            return new Promise((resolve, reject) => {
                // 创建表单数据
                const formData = new FormData();
                formData.append('registrationId', this.form.registrationId);
                formData.append('file', file.raw || file);

                // 添加初始状态设置
                this.$set(fileList[index], 'status', 'uploading');
                this.$set(fileList[index], 'percentage', 0);

                // 发送上传请求
                this.$axios.post('/web/file/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        this.$set(fileList[index], 'percentage', percentCompleted);
                    }
                }).then(response => {
                    if (response.status === 200) {
                        // 更新文件状态为成功
                        this.$set(fileList[index], 'status', 'parsed');
                        this.$set(fileList[index], 'parsed', true);
                        this.$set(fileList[index], 'percentage', 100);

                        // 更新URL列表
                        const fileName = fileList[index].name;
                        if (!urlList.includes(fileName)) {
                            urlList.push(fileName);
                        }

                        // 同步到form对象中
                        if (urlList === this.reportUrlList) {
                            this.form.reportUrlList = [...this.reportUrlList];
                        } else if (urlList === this.detailExcelUrlList) {
                            this.form.detailExcelUrlList = [...this.detailExcelUrlList];
                        } else if (urlList === this.bookUrlList) {
                            this.form.bookUrlList = [...this.bookUrlList];
                        } else if (urlList === this.otherUrlList) {
                            this.form.otherUrlList = [...this.otherUrlList];
                        }

                        resolve(response.data.object);
                    } else {
                        this.$set(fileList[index], 'status', 'error');
                        reject(new Error(response.msg || '文件上传失败'));
                    }
                }).catch(error => {
                    this.$set(fileList[index], 'status', 'error');
                    reject(error);
                });
            });
        },


        // 报告文件选择
        reportFileChange(file, fileList) {
            // 验证文件
            if (!this.validateReportFile(file)) {
                // 移除无效文件
                const index = fileList.findIndex(f => f.uid === file.uid);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }
            this.reportFileList = fileList;
            // this.allFileList.push(file);
        },
        // 报告文件移除
        handleReportRemove() { },
        // 处理删除报告文件的方法
        removeReportFileFromList(index) {
            // 从文件列表中删除
            this.reportFileList.splice(index, 1);
            this.$message.success('文件已删除');
        },
        // 报告文件清空
        clearReportFiles() {
            this.reportFileList = [];
            this.$message.success('文件列表已清空');
        },
        // 单个报告文件上传
        singleReportFilesUpload(index) {
            // 设置上传状态为正在进行
            this.isUploading = true;
            this.singleReportPromises.push(this.singleFilesUpload(this.reportFileList, this.reportUrlList, index))
            // 等待所有上传完成
            Promise.all(this.singleReportPromises)
                .then(() => {
                    this.$message.success('所有文件上传完成');
                })
                .catch(() => {
                    this.$message.error('部分文件上传失败');
                })
                .finally(() => {
                    // 重置上传状态
                    this.isUploading = false;
                });
        },
        // 所有报告文件上传
        allReportFilesUpload() {
            // 设置上传状态为正在进行
            this.isUploading = true;

            // 创建所有上传任务的Promise数组
            const uploadPromises = [];
            for (let i = 0; i < this.reportFileList.length; i++) {
                uploadPromises.push(this.singleFilesUpload(this.reportFileList, this.reportUrlList, i));
            }

            // 等待所有上传完成
            Promise.all(uploadPromises)
                .then(() => {
                    this.$message.success('所有文件上传完成');
                })
                .catch(() => {
                    this.$message.error('部分文件上传失败');
                })
                .finally(() => {
                    // 重置上传状态
                    this.isUploading = false;
                });
        },


        // 详情文件选择
        detailExcelFileChange(file, fileList) {
            // 验证文件
            if (!this.validateDetailExcelFile(file)) {
                // 移除无效文件
                const index = fileList.findIndex(f => f.uid === file.uid);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }
            this.detailExcelFileList = fileList;
            // this.allFileList.push(file);
        },
        // 详情文件移除
        handleDetailExcelRemove() { },
        // 处理删除详细文件的方法
        removeDetailExcelFileFromList(index) {
            // 从文件列表中删除
            this.detailExcelFileList.splice(index, 1);
            this.$message.success('文件已删除');
        },
        // 详细文件清空
        clearDetailExcelFiles() {
            this.detailExcelFileList = [];
            this.$message.success('文件列表已清空');
        },
        // 单个详细文件上传
        singleDetailExcelFilesUpload(index) {
            // 设置上传状态为正在进行
            this.isDetailExcelUploading = true;
            this.singleDetailExcelPromises.push(this.singleFilesUpload(this.detailExcelFileList, this.detailExcelUrlList, index))
            // 等待所有上传完成   
            Promise.all(this.singleDetailExcelPromises)
                .then(() => {
                    this.$message.success('所有文件上传完成');
                })
                .catch(() => {
                    this.$message.error('部分文件上传失败');
                })
                .finally(() => {
                    // 重置上传状态
                    this.isDetailExcelUploading = false;
                });
        },
        // 所有详细文件上传
        allDetailExcelFilesUpload() {
            // 设置上传状态为正在进行
            this.isDetailExcelUploading = true;

            // 创建所有上传任务的Promise数组
            const uploadPromises = [];
            for (let i = 0; i < this.detailExcelFileList.length; i++) {
                uploadPromises.push(this.singleFilesUpload(this.detailExcelFileList, this.detailExcelUrlList, i));
            }

            // 等待所有上传完成
            Promise.all(uploadPromises)
                .then(() => {
                    this.$message.success('所有文件上传完成');
                })
                .catch(() => {
                    this.$message.error('部分文件上传失败');
                })
                .finally(() => {
                    // 重置上传状态
                    this.isDetailExcelUploading = false;
                });
        },


        // 承诺书选择
        bookFileChange(file, fileList) {
            // 验证文件
            if (!this.validateBookFile(file)) {
                // 移除无效文件
                const index = fileList.findIndex(f => f.uid === file.uid);
                if (index > -1) {
                    fileList.splice(index, 1);
                }
                return;
            }
            this.bookFileList = fileList;
            // this.allFileList.push(file);
        },
        // 承诺书移除
        handleBookRemove() { },
        // 承诺书删除
        removeBookFileFromList(index) {
            // 从文件列表中删除
            this.bookFileList.splice(index, 1);
            this.$message.success('文件已删除');
        },
        // 承诺书文件清空
        clearBookFiles() {
            this.bookFileList = [];
            this.$message.success('文件列表已清空');
        },
        // 单个承诺书文件上传
        singleBookFilesUpload(index) {
            // 设置上传状态为正在进行
            this.isBookUploading = true;
            this.singleBooklPromises.push(this.singleFilesUpload(this.bookFileList, this.bookUrlList, index))
            // 等待所有上传完成   
            Promise.all(this.singleBooklPromises)
                .then(() => {
                    this.$message.success('所有文件上传完成');
                })
                .catch(() => {
                    this.$message.error('部分文件上传失败');
                })
                .finally(() => {
                    // 重置上传状态
                    this.isBookUploading = false;
                });
        },
        // 所有承诺书文件上传
        allBookFilesUpload() {
            // 设置上传状态为正在进行
            this.isBookUploading = true;

            // 创建所有上传任务的Promise数组
            const uploadPromises = [];
            for (let i = 0; i < this.bookFileList.length; i++) {
                uploadPromises.push(this.singleFilesUpload(this.bookFileList, this.bookUrlList, i));
            }

            // 等待所有上传完成
            Promise.all(uploadPromises)
                .then(() => {
                    this.$message.success('所有文件上传完成');
                })
                .catch(() => {
                    this.$message.error('部分文件上传失败');
                })
                .finally(() => {
                    // 重置上传状态
                    this.isBookUploading = false;
                });
        },



        // 其他文件选择
        otherFileChange(file, fileList) {

            this.otherFileList = fileList;
            // this.allFileList.push(file);
        },
        // 其他文件移除
        handleOtherRemove() { },
        // 其他文件删除
        removeOtherFileFromList(index) {
            // 从文件列表中删除
            this.otherFileList.splice(index, 1);
            this.$message.success('文件已删除');
        },
        // 其他文件清空
        clearOtherFiles() {
            this.otherFileList = [];
            this.$message.success('文件列表已清空');
        },
        // 单个其他文件上传
        singleOtherFilesUpload(index) {
            // 设置上传状态为正在进行
            this.isOtherUploading = true;
            this.singleOtherlPromises.push(this.singleFilesUpload(this.otherFileList, this.otherUrlList, index))
            // 等待所有上传完成   
            Promise.all(this.singleOtherlPromises)
                .then(() => {
                    this.$message.success('所有文件上传完成');
                })
                .catch(() => {
                    this.$message.error('部分文件上传失败');
                })
                .finally(() => {
                    // 重置上传状态
                    this.isOtherUploading = false;
                });
        },
        // 所有其他文件上传
        allOtherFilesUpload() {
            // 设置上传状态为正在进行
            this.isOtherUploading = true;

            // 创建所有上传任务的Promise数组
            const uploadPromises = [];
            for (let i = 0; i < this.otherFileList.length; i++) {
                uploadPromises.push(this.singleFilesUpload(this.otherFileList, this.otherUrlList, i));
            }

            // 等待所有上传完成
            Promise.all(uploadPromises)
                .then(() => {
                    this.$message.success('所有文件上传完成');
                })
                .catch(() => {
                    this.$message.error('部分文件上传失败');
                })
                .finally(() => {
                    // 重置上传状态
                    this.isOtherUploading = false;
                });
        },


        async downloadFile(customName) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/template/download/' + customName,
                    responseType: 'blob'
                });

                // 优先使用传入的自定义文件名
                let fileName = customName;
                //这里把文件名替换成中文，上面用英文是避免网络传输乱码问题，这里换成中文文件名下载时就正常了
                if (customName.startsWith('DataDetailTemplate')) {
                    fileName = "数据资产查验详情表-模版.xlsx"
                } else if (customName.startsWith('DataReportTemplate')) {
                    fileName = "数据资产查验报告-模版.docx"
                } else if (customName.startsWith('CommitWordTemplate')) {
                    fileName = "数据资产登记承诺书-模版.docx"
                } else if (customName.startsWith('Hash')) {
                    fileName = "哈希值生成工具.zip"
                }

                // 处理中文文件名编码问题
                const encodedFileName = encodeURIComponent(fileName);

                // 创建下载链接
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                link.setAttribute('download-filename', encodedFileName); // 兼容性处理
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                console.error('下载失败:', error);
                this.$message.error('文件下载失败: ' + error.message);
            }
        },

        updateRightsType() {
            let result = '000'.split('');
            this.rightsTypeSelected.forEach(type => {
                if (type === '100') result[0] = '1';
                if (type === '010') result[1] = '1';
                if (type === '001') result[2] = '1';
            });
            this.form.rightsType = result.join('');

            // 更新校验状态
            this.rightsTypeValidation = {
                valid: this.rightsTypeSelected.length > 0,
                message: this.rightsTypeSelected.length > 0 ? '' : '请至少选择一种权利类型'
            };
        },
        submitForm() {
            this.updateRightsType();
            // 校验必传文件是否上传

            const formatDate = (date) => {
                if (!date) return '';
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            const updateCycleMap = {
                '实时': 'realtime',
                '每日': 'daily',
                '每周': 'weekly',
                '每月': 'monthly',
                '每季度': 'quarterly',
                '每年': 'yearly',
                'realtime': 'realtime',
                'daily': 'daily',
                'weekly': 'weekly',
                'monthly': 'monthly',
                'quarterly': 'quarterly',
                'yearly': 'yearly'
            }
            const englishUpdateCycle = updateCycleMap[this.form.updateCycle] || this.form.updateCycle;

            const submitData = {
                ...this.form,

                industry: this.form.industrys && this.form.industrys.length > 1
                    ? this.form.industrys[1] : '',
                updateCycle: englishUpdateCycle,
                registrationId: this.form.registrationId.toString(),
                reportFile: this.reportUrlList.toString(),
                verificationFile: this.detailExcelUrlList.toString(),
                commitmentFile: this.bookUrlList.toString(),
                otherFile: this.otherUrlList,
                dataStartTime: formatDate(this.form.dataStartTime),
                dataEndTime: formatDate(this.form.dataEndTime),
                assetsStartTime: formatDate(this.form.assetsStartTime),
                assetsEndTime: formatDate(this.form.assetsEndTime)
            };
            // 合并合规材料数据
            if (this.complianceSubmitData) {
                Object.assign(submitData, this.complianceSubmitData);
            }
            console.log("最终提交数据");
            console.log(submitData);

            this.postRequest('/web/dataAssets/add', submitData)
                .then(response => {
                    this.$loading().close();
                    if (response.status === 200) {
                        this.$confirm('数据资产提交成功！', '提示', {
                            confirmButtonText: '确定',
                            type: 'success',
                            showCancelButton: false
                        }).then(() => {
                            // 确定后跳转到DataProperty页面
                            this.$router.push('/DataProperty');
                        });
                    } else {
                        this.$message.error(response.msg || '提交失败');
                    }
                })
                .catch(error => {
                    this.$loading().close();
                    this.$message.error('网络错误，请稍后重试');
                    console.error('提交失败:', error);
                });
        },


    },
    computed: {
        canSubmit() {
            // 检查三个必填文件类型是否都有文件且所有文件都上传成功
            const allReportsUploaded = this.reportFileList.length > 0 &&
                this.reportFileList.every(file => file.status === 'parsed');

            const allDetailExcelsUploaded = this.detailExcelFileList.length > 0 &&
                this.detailExcelFileList.every(file => file.status === 'parsed');

            const allBooksUploaded = this.bookFileList.length > 0 &&
                this.bookFileList.every(file => file.status === 'parsed');

            // 检查是否有任何文件正在上传（包括报告、详情表、承诺书、其他文件）
            const isAnyFileUploading =
                this.reportFileList.some(file => file.status === 'uploading' || file.status === 'parsing') ||
                this.detailExcelFileList.some(file => file.status === 'uploading' || file.status === 'parsing') ||
                this.bookFileList.some(file => file.status === 'uploading' || file.status === 'parsing') ||
                this.otherFileList.some(file => file.status === 'uploading' || file.status === 'parsing');

            // 只有三个必填文件都有文件且全部上传成功，且没有任何文件正在上传时，才允许提交

            return allReportsUploaded && allDetailExcelsUploaded && allBooksUploaded && !isAnyFileUploading;
        },
        // 获取行业标签
        getIndustryLabel() {
            if (!this.form.industrys || this.form.industrys.length === 0) {
                return '未选择';
            }
            // 查找对应的行业名称
            for (let parent of this.industryOptions) {
                if (parent.value === this.form.industrys[0]) {
                    if (this.form.industrys.length > 1 && parent.children) {
                        for (let child of parent.children) {
                            if (child.value === this.form.industrys[1]) {
                                return `${parent.label} / ${child.label}`;
                            }
                        }
                    }
                    return parent.label;
                }
            }
            return '未知行业';
        },
        // 新增：计算下一步按钮是否禁用
        isNextStepDisabled() {
            // 如果是第三步，检查子组件状态
            if (this.activeStep === 3) {
                console.log(this.complianceUploadStatus.hasUploading);
                console.log(this.complianceUploadStatus.hasUnuploaded);
                return this.complianceUploadStatus.hasUploading ||
                    this.complianceUploadStatus.hasUnuploaded;
            }
            return false;
        }
    },
}
</script>

<style scoped>
.data-registration-container {
    min-width: 800px;
    max-width: 1600px;
    width: 100%;
    margin: 0 auto;
    overflow-x: hidden;
    padding: 20px;
}

.el-form-item__label {
    text-align: left;
    justify-content: flex-start;
}

.form-step {
    margin-top: 30px;
    max-width: 1400px;
    padding: 20px;
    background: #fafafa;
    border-radius: 8px;
}

.step-form {
    background: white;
    padding: 30px;
    border-radius: 8px;
    margin-top: 20px;
}

.step-tip {
    margin-bottom: 20px;
}

.template-download-links {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    margin-top: 10px;
}

.template-download-links .el-link {
    font-size: 14px;
}

.form-actions {
    margin-top: 40px;
    padding: 20px;
    text-align: center;
    background: white;
    border-top: 1px solid #ebeef5;
}

.form-actions .el-button {
    min-width: 120px;
    margin: 0 10px;
}

.file-preview {
    margin-top: 10px;
    padding: 10px;
    background: #faf8f5;
    border-radius: 4px;
    display: flex;
    width: 355px;
    height: 35px;
    align-items: center;
}

.file-preview-1 {
    margin-top: 10px;
    padding: 10px;
    color: rgb(35, 141, 58);
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    width: 355px;
    height: 35px;
    align-items: center;
}

.file-preview i {
    margin-right: 10px;
    color: #409EFF;
    font-size: 20px;
}

.upload-container {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    padding: 20px;
    width: 400px;
    height: 220px;
    margin-bottom: 20px;
    background: #ffffff;
}

.upload-container-1 {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    padding: 20px;
    width: 400px;
    height: 220px;
    margin-bottom: 20px;
    background: #faf9f8fb;
}

.upload-header {
    margin-bottom: 15px;
    font-size: 14px;
    color: #606266;
}

.required-mark {
    color: #f56c6c;
    margin-right: 5px;
}

/* 表单分组卡片样式 */
.form-section-card {
    margin-bottom: 20px;
    border: 1px solid #EBEEF5;
}

.form-section-card .section-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #303133;
}

.form-section-card .section-header i {
    margin-right: 8px;
    font-size: 18px;
    color: #409EFF;
}

/* 上传区域卡片样式 */
.upload-card {
    margin-bottom: 24px;
    border: 1px solid #EBEEF5;
}

.upload-card .card-header {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 500;
    color: #303133;
}

.upload-card .card-header .required-mark {
    color: #f56c6c;
    margin-right: 4px;
}

.upload-card .card-header i {
    margin-right: 8px;
    font-size: 16px;
    color: #409EFF;
}

.info-icon {
    margin-left: 5px;
    color: #c0c4cc;
    cursor: pointer;
}

.info-icon-2 {
    margin-left: 5px;
    color: #cf981f;
    cursor: pointer;
}



.download-link {
    color: #409EFF;
    cursor: pointer;
    margin-right: 15px;
    font-size: 14px;
}

.download-link:hover {
    text-decoration: underline;
}

.file-name-row {
    display: flex;
    align-items: center;
    padding: 4px 0;
    font-size: 13px;
    color: #303133;
}

.file-name-row + .file-name-row {
    border-top: 1px solid #F2F6FC;
}

.upload-area {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 150px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    background: #fafafa;
}

.upload-area-1 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 150px;
    height: 150px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    background: #ffffff;
}

.upload-area:hover {
    border-color: #409EFF;
}

.upload-icon {
    font-size: 28px;
    color: #8c939d;
}

/* 选中按钮的蓝色样式 */
.el-radio-button.is-active {
    color: #fff;
    background-color: #409EFF;
    border-color: #409EFF;
    box-shadow: -1px 0 0 0 #409EFF;
}

/* 高亮显示的复选框组 */
.highlight-checkbox-group .el-checkbox.is-checked .el-checkbox__inner {
    background-color: #409EFF;
    border-color: #409EFF;
}

.highlight-checkbox-group .el-checkbox__label {
    font-weight: bold;
    color: #409EFF;
}

.container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
}
</style>